const baseUrl = (process.env.NEXT_PUBLIC_CDN_URL || '').replace(/\/+$/, '');

export const resolveImageUrl = (path?: string | null) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const cleanPath = path.replace(/^\/+/, '');
    if (!baseUrl) return `/${cleanPath}`;
    return `${baseUrl}/${cleanPath}`;
};
